import React from 'react';
import classNames from 'classnames';

export interface DividerProps {
  /**
   * @ignore
   * Classes applied to the root element.
   */
  className?: string;
}

/**
 * Dividers are used to divide sections of content.
 *
 * @see https://www.figma.com/file/0InvjWy5vBj5uz4ajwIKaj/Patient-AI?type=design&node-id=12767%3A130193&mode=design&t=P78BtNI1rUmlTyjy-1
 */
const Divider = React.forwardRef(
  ({ className }: DividerProps, ref: React.ForwardedRef<HTMLHRElement>) => {
    return <hr className={classNames('ds-divider', className)} ref={ref} />;
  },
);

Divider.displayName = 'Divider';

export default Divider;
